import React, { useState, useContext } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { GoogleLogin } from '@react-oauth/google';
import { apiFetch } from '../utils/api';
import '../styles/auth.css';

const Register = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await apiFetch('/api/auth/register', {
        method: 'POST',
        body: JSON.stringify({ name, email, password })
      });
      const data = await res.json();
      if (res.ok) {
        // Show backend message (covers both new registration and existing-unverified)
        alert(data.message || 'Registration successful. Please check your email for the OTP.');
        navigate(`/verify-otp?email=${encodeURIComponent(email)}`);
      } else {
        alert(data.message);
      }
    } catch (error) {
      console.error(error);
      alert('An error occurred during registration.');
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleSuccess = async (credentialResponse) => {
    setLoading(true);
    try {
      const res = await apiFetch('/api/auth/google', {
        method: 'POST',
        body: JSON.stringify({ credential: credentialResponse.credential })
      });
      const data = await res.json();

      if (res.ok && data.success) {
        login({
          _id: data.user._id,
          name: data.user.name,
          email: data.user.email,
          role: data.user.role,
          avatar: data.user.avatar
        });
        navigate('/');
      } else {
        alert(data.message || 'Google signup failed');
      }
    } catch (error) {
      console.error('Google register error:', error);
      alert('An error occurred during Google Sign-in.');
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleError = () => {
    alert('Google sign-in failed. Please try again.');
  };

  return (
    <div className="auth-container">
      <form onSubmit={handleSubmit} className="auth-form">
        <h2>Register</h2>
        <input type="text" placeholder="Full Name" value={name} onChange={(e) => setName(e.target.value)} required disabled={loading} />
        <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required disabled={loading} />
        <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required disabled={loading} />
        <button type="submit" className="btn" disabled={loading}>
          {loading ? 'Please wait...' : 'Register'}
        </button>
        <p>Already have an account? <Link to="/login">Login</Link></p>

        <div className="auth-divider">
          <span className="line"></span>
          <span className="text">OR</span>
          <span className="line"></span>
        </div>

        <div className={`google-btn-container ${loading ? 'disabled' : ''}`}>
          <GoogleLogin
            onSuccess={handleGoogleSuccess}
            onError={handleGoogleError}
            theme="filled_black"
            text="continue_with"
            shape="rectangular"
            width="100%"
          />
        </div>
      </form>
    </div>
  );
};

export default Register;
